function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_802",
  "data-name": "Group 802",
  transform: "translate(2.828 2.828)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x2: 4.115,
  y2: 4.115,
  transform: "translate(0 4.938)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  y1: 9.054,
  x2: 9.054,
  transform: "translate(4.115)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 4
}));

var SvgHandlingCosts = function SvgHandlingCosts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.826,
    height: 14.711,
    viewBox: "0 0 18.826 14.711",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandlingCosts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/handling-costs.bbfdc676.svg";
export { ForwardRef as ReactComponent };